module.exports = __webpack_public_path__ + "img/js.3a5dd5ad.svg";